import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const carrollwoodConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Carrollwood Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Carrollwood, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_carrollwood',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Carrollwood',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Carrollwood Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we serve the well established 
     neighborhoods of <strong>Carrollwood</strong> with professional tree care 
     that homeowners here can rely on. This community features mature trees 
     throughout its subdivisions and golf course areas trees that add beauty 
     and shade but also require regular professional attention as they age and 
     grow. Storm season in Florida makes staying ahead of tree hazards essential.`,

    `We specialize in <strong>hazardous tree removal and canopy management</strong> 
     large overhanging limbs near homes and driveways, storm weakened trunks, 
     trees with root damage from years of growth, and dense canopy thinning 
     that reduces wind load risk before hurricane season. We work efficiently 
     and leave your property clean.`,

    `<strong>Sam's Tree Service</strong> delivers reliable, affordable tree care 
     throughout <strong>Carrollwood</strong> and surrounding 
     <strong>Northwest Tampa</strong> communities keeping your home and 
     landscape safe and well maintained through every season.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Carrollwood, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Carrollwood = () => <LocationPage config={carrollwoodConfig} />;
export default Services_Carrollwood;
